module.exports = __webpack_public_path__ + "img/it.5c3ea788.svg";